import React from "react";
import { MDCAnchorMenu, MDCMenu } from "../../jsx/components/mdc-components";
export default class UtmFilter extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "heading-label orange dropdown"
    }, /*#__PURE__*/React.createElement("span", {
      className: "heading-span"
    }, "Utm Activity"), /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: this.props.id,
      onMenuSelected: this.props.onSelected,
      cls: "small-list-item-size"
    }, /*#__PURE__*/React.createElement("button", {
      className: "anchor-menu-button with-heading",
      "data-anchor": true
    }, this.props.selection, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons white-color"
    }, "arrow_drop_down")), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: this.props.id
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "All",
      "data-id": "Source"
    }, "All"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Source",
      "data-id": "Source"
    }, "Source"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Medium",
      "data-id": "Medium"
    }, "Medium"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Term",
      "data-id": "Term"
    }, "Term"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Content",
      "data-id": "Content"
    }, "Content"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "Campaign",
      "data-id": "Campaign"
    }, "Campaign"))));
  }
}